export default __webpack_public_path__ + "static/media/aboutus.c4073fb3.png";